import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ServiceInterceptor } from '@core/service/interceptor.interceptor';
import { Observable, Subject } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Pais } from '@core/model/pais.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaisService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;

  protected data$ = new Subject<Pais[]>();
  /*0: {pais_id: 1, nombre: "BOLIVIA"}
  1: {pais_id: 2, nombre: "BRASIL"}
  2: {pais_id: 3, nombre: "ARGENTINA"}*/
  stringData$ = this.data$.asObservable();

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/paises';
    this.data$.next([]);
  }

  // constructor(protected httpClient: HttpClient, protected inter: ServiceInterceptor) {
  //   super(httpClient);
  //   this.baseUrl = '/paises';
  // }

  gethabilitados(): Observable<Pais[]> {
    return this.httpClient.get<Pais[]>(this.baseUrl + `/habilitados`);
  }

  getAll(filterObject?: any): Observable<any> {
    return super.getAll(filterObject);
  }

  /*  getAll(filterObject?: any): Observable<any> {
     this.httpClient.get(`${this.baseUrl}`).subscribe(res => {
        console.log(res);
      });


      return this.data$;
    }*/
}
